module.exports = __webpack_public_path__ + "img/2364b27.jpg";